export default __webpack_public_path__ + "static/media/p01 p04.ab1a99bb.jpg";